import { cn } from "helpers/classNames";
import { ReactNode } from "react";

interface Props extends React.ComponentPropsWithoutRef<"div"> {
  children?: ReactNode;
}
export const ShadowCard = ({ children, className, ...rest }: Props) => (
  <div
    className={cn(
      "flex flex-col divide-y divide-gray-200 rounded-lg border border-gray-100 bg-white shadow",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export const HeaderContainer = ({ children, className, ...rest }: Props) => (
  <div
    className={cn(
      "flex items-center justify-between px-4 py-4 sm:px-6",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export const ContentContainer = ({ children, className, ...rest }: Props) => (
  <div
    className={cn("flex-1 justify-center px-4 py-5 sm:px-6 sm:py-6", className)}
    {...rest}
  >
    {children}
  </div>
);
